const urls = {
  CLIENT: process.env.REACT_APP_CLIENT,
  SERVER: process.env.REACT_APP_SERVER,
  ADMIN_CLIENT: process.env.REACT_APP_ADMIN_CLIENT,
  ADMIN_SERVER: process.env.REACT_APP_ADMIN_SERVER,
};

export default urls;
